import { render, staticRenderFns } from "./CollaboratorInputTag.vue?vue&type=template&id=2bb309f0&scoped=true"
import script from "./CollaboratorInputTag.vue?vue&type=script&lang=js"
export * from "./CollaboratorInputTag.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorInputTag.vue?vue&type=style&index=0&id=2bb309f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb309f0",
  null
  
)

export default component.exports